import { Container, Row, Col, Image } from 'react-bootstrap'

const WhatYouWillLearn = () => (
    <>
    <div className="section-what-you-will-learn text-center">
        <Container>
            <Image src="../images/7bs/img-arrow-down01.png" alt="" className="img-fluid d-block mx-auto mb-md-5 mb-0 arrow-down"/>
            <h2 className="mb-5 pb-md-4 pb-0">Here's what you will learn in this special report</h2>
            <Row>
                <Col md={4} className="mb-4">
                    <Image src="../images/7bs/img-plan01.jpg" alt="How To Create A Plan" className="img-fluid d-block mx-auto mb-4"/>
                    <p>How to create a plan that is sustainable and works quickly</p>
                </Col>
                <Col md={4} className="mb-4">
                    <Image src="../images/7bs/img-meal01.jpg" alt="Meals You Want To Eat A Day" className="img-fluid d-block mx-auto mb-4"/>
                    <p>How many meals you want to eat a day to boost your metabolism and burn fat</p>
                </Col>
                <Col md={4} className="mb-4">
                    <Image src="../images/7bs/img-5-key01.jpg" alt="5 Key Factors To A Fat Burning Workout" className="img-fluid d-block mx-auto mb-4"/>
                    <p>The 5 key factors to a fat burning workout you can do in less than 30 minutes a day</p>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-what-you-will-learn {
                background: #EEE9E3;
                font-size: 24px;
            }

            .section-what-you-will-learn .container {
                padding-bottom: 70px;
            }

            .section-what-you-will-learn h2 {
                color: #de7621;
                font-size: 40px;
            }

            .section-what-you-will-learn .arrow-down {
                position: relative;
                top: -30px;
            }

            @media (max-width: 767.98px) {

                .section-what-you-will-learn {
                    font-size: 18px;
                }

                .section-what-you-will-learn .container {
                    padding-bottom: 40px;
                }

                .section-what-you-will-learn h2 {
                    font-size: 30px;
                }

            }

        `}</style>
    </>
);

export default WhatYouWillLearn;